export const PageHeader = ({ eyebrow, title, testid, children, sub }) => (
  <header className="mb-10 flex flex-wrap items-end justify-between gap-6 animate-rise">
    <div>
      {eyebrow && <p className="mb-3 text-[10px] font-semibold uppercase tracking-[0.25em] text-amber-700">{eyebrow}</p>}
      <h1 className="font-heading text-4xl font-bold tracking-tight sm:text-5xl lg:text-6xl" data-testid={testid}>{title}</h1>
      {sub && <p className="mt-3 text-sm text-zinc-500">{sub}</p>}
    </div>
    {children}
  </header>
);
